import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ICitizenEditPayload } from './cetatean-accounts.interface';

@Injectable({
    providedIn: 'root'
})
export class CetateanAccountsService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private getCitizensDTURL =
        this.basePath + environment.interop.platform.nomenclatoare.citizen.getCitizensDT;
    private updateCitizenURL =
        this.basePath + environment.interop.platform.nomenclatoare.citizen.updateCitizen;
    private getCitizenByIdURL = this.basePath + environment.interop.platform.nomenclatoare.citizen.getCitizen;
    private searchCitizenURL = this.basePath + environment.interop.platform.nomenclatoare.citizen.searchCitizen;

    constructor(private http: HttpClient) { }

    getCitizensDT() {
        return this.http.get(this.getCitizensDTURL, this.httpOptions);
    }

    updateCitizen(citizen: ICitizenEditPayload) {
        return this.http.post(this.updateCitizenURL, citizen, this.httpOptions);
    }

    getCitizenById(id: number) {
        return this.http.get(this.getCitizenByIdURL + id, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
